module.exports = "<div class=\"rg-groups\"></div>\n";
